(function(){
/* Zumm Health — Science page */
const {
  motion
} = window.Motion;
const {
  Nav,
  Footer,
  TopBar,
  Microbes,
  Reveal,
  fadeUp,
  stagger
} = window.Z;
function SciencePage() {
  const pillars = [{
    ico: '🛡️',
    title: 'Delivery that survives the stomach',
    text: 'Live probiotics are fragile — stomach acid destroys much of an ordinary capsule’s cultures before they arrive. Our probiotics use delayed‑release capsules (DRcaps® for kids, hypromellose for adults) engineered to resist acid and open lower down, so more live cultures reach the intestines where they can go to work.*'
  }, {
    ico: '🦠',
    title: 'Strain diversity, not just big numbers',
    text: 'A high CFU count means little if it’s one strain. Our probiotics combine multiple researched species of Lactobacillus and Bifidobacterium (plus Saccharomyces boulardii in the kids’ formula) because a diverse microbiome is a resilient one.*'
  }, {
    ico: '🌵',
    title: 'Prebiotics to feed the probiotics',
    text: 'Probiotics are living things — they need food. We pair our cultures with prebiotic fiber (organic inulin from blue agave and Jerusalem artichoke, or FOS for kids) so the good bacteria you take have fuel to establish and thrive.*'
  }, {
    ico: '⚙️',
    title: 'Enzymes for real‑world digestion',
    text: 'Meals are a mix of proteins, starches, fats and dairy. Our digestive enzyme complexes (up to nine enzymes, including lactase) support the breakdown of everyday foods — for more comfortable digestion.*'
  }, {
    ico: '🚫',
    title: 'Subtraction as a design choice',
    text: 'No sugar, no artificial colors, flavors or sweeteners. Removing them isn’t marketing — added sugar feeds the wrong microbes and undercuts the point of a gut supplement in the first place.'
  }, {
    ico: '🔬',
    title: 'Verified, not just claimed',
    text: 'Formulas are produced in GMP‑certified facilities and third‑party tested for identity, potency and purity — so the strains and doses on the label are the ones in the bottle.'
  }];
  const strains60 = ['L. plantarum', 'L. bulgaricus', 'S. thermophilus', 'B. longum', 'L. acidophilus', 'L. casei', 'L. salivarius', 'L. rhamnosus', 'B. lactis', 'B. bifidum'];
  const strains24 = ['B. lactis', 'B. animalis', 'L. rhamnosus', 'B. longum', 'L. acidophilus', 'B. coagulans', 'S. boulardii'];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TopBar, null), /*#__PURE__*/React.createElement(Nav, {
    current: "science.html"
  }), /*#__PURE__*/React.createElement("header", {
    className: "pp-hero",
    style: {
      '--pp-glow': 'rgba(94,139,196,.5)'
    }
  }, /*#__PURE__*/React.createElement(Microbes, {
    count: 14
  }), /*#__PURE__*/React.createElement("div", {
    className: "wrap",
    style: {
      textAlign: 'center',
      maxWidth: 920,
      margin: '0 auto'
    }
  }, /*#__PURE__*/React.createElement(motion.div, {
    initial: "hidden",
    animate: "visible",
    variants: stagger
  }, /*#__PURE__*/React.createElement(motion.span, {
    className: "eyebrow",
    variants: fadeUp
  }, "The Science"), /*#__PURE__*/React.createElement(motion.h1, {
    className: "h-xl",
    variants: fadeUp,
    style: {
      margin: '22px 0 20px'
    }
  }, "What makes a supplement", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", {
    className: "accent-blue"
  }, "actually work?")), /*#__PURE__*/React.createElement(motion.p, {
    className: "lead",
    variants: fadeUp,
    style: {
      margin: '0 auto'
    }
  }, "It's not the flavor or the shape. It's whether the active ingredients survive the journey, arrive in the right place, and are backed by real doses. Here's the thinking behind every Zumm formula.")))), /*#__PURE__*/React.createElement("section", {
    className: "section"
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement(Reveal, null, /*#__PURE__*/React.createElement("span", {
    className: "eyebrow green"
  }, "Six Principles")), /*#__PURE__*/React.createElement(Reveal, null, /*#__PURE__*/React.createElement("h2", {
    className: "h-lg",
    style: {
      margin: '18px 0 46px',
      maxWidth: 720
    }
  }, "How we design for ", /*#__PURE__*/React.createElement("span", {
    className: "accent-green"
  }, "the gut"))), /*#__PURE__*/React.createElement(Reveal, {
    className: "sci-cards",
    variants: stagger,
    amount: .12
  }, pillars.map(p => /*#__PURE__*/React.createElement(motion.div, {
    className: "sci-card",
    key: p.title,
    variants: fadeUp,
    whileHover: {
      y: -8
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "ico"
  }, p.ico), /*#__PURE__*/React.createElement("h3", null, p.title), /*#__PURE__*/React.createElement("p", null, p.text)))))), /*#__PURE__*/React.createElement("section", {
    className: "section",
    style: {
      paddingTop: 20
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement(Reveal, null, /*#__PURE__*/React.createElement("span", {
    className: "eyebrow orange"
  }, "Inside the Blend")), /*#__PURE__*/React.createElement(Reveal, null, /*#__PURE__*/React.createElement("h2", {
    className: "h-lg",
    style: {
      margin: '18px 0 40px'
    }
  }, "The ", /*#__PURE__*/React.createElement("span", {
    className: "accent-orange"
  }, "strains"), " we use")), /*#__PURE__*/React.createElement("div", {
    className: "sci-cards"
  }, /*#__PURE__*/React.createElement(Reveal, {
    className: "sci-card",
    amount: .2
  }, /*#__PURE__*/React.createElement("div", {
    className: "ico"
  }, "💪"), /*#__PURE__*/React.createElement("h3", null, "Pro Max — 60 Billion CFU"), /*#__PURE__*/React.createElement("p", null, "Ten strains for adults and kids 4+, built for broad‑spectrum support.*"), /*#__PURE__*/React.createElement("div", {
    className: "strain-chips"
  }, strains60.map(s => /*#__PURE__*/React.createElement("span", {
    className: "chip",
    key: s
  }, s)))), /*#__PURE__*/React.createElement(Reveal, {
    className: "sci-card",
    amount: .2
  }, /*#__PURE__*/React.createElement("div", {
    className: "ico"
  }, "🧒"), /*#__PURE__*/React.createElement("h3", null, "Buds Pro Jr. — 24 Billion CFU"), /*#__PURE__*/React.createElement("p", null, "Seven kid‑friendly strains, including Saccharomyces boulardii, in an acid‑resistant capsule.*"), /*#__PURE__*/React.createElement("div", {
    className: "strain-chips"
  }, strains24.map(s => /*#__PURE__*/React.createElement("span", {
    className: "chip blue",
    key: s
  }, s))))))), /*#__PURE__*/React.createElement("section", {
    className: "section",
    style: {
      paddingTop: 20
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement(Reveal, {
    className: "quoteband",
    amount: .4
  }, /*#__PURE__*/React.createElement("span", {
    className: "eyebrow"
  }, "The Bottom Line"), /*#__PURE__*/React.createElement("h2", {
    className: "h-md",
    style: {
      marginTop: 18
    }
  }, "Delivery, diversity, dose and honesty. Get those four right and you don't need sugar to make a supplement worth taking.")))), /*#__PURE__*/React.createElement("section", {
    className: "section",
    style: {
      paddingTop: 10,
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "wrap"
  }, /*#__PURE__*/React.createElement(Reveal, null, /*#__PURE__*/React.createElement("h2", {
    className: "h-lg",
    style: {
      marginBottom: 20
    }
  }, "See it on the label")), /*#__PURE__*/React.createElement(Reveal, null, /*#__PURE__*/React.createElement("p", {
    className: "lead",
    style: {
      margin: '0 auto 30px'
    }
  }, "Every claim here maps to a real Supplement Facts panel. Read them yourself.")), /*#__PURE__*/React.createElement(Reveal, {
    style: {
      display: 'flex',
      gap: 14,
      justifyContent: 'center',
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/React.createElement(motion.a, {
    className: "btn btn-green",
    href: "probiotic-60.html",
    whileHover: {
      scale: 1.05
    },
    whileTap: {
      scale: .95
    }
  }, "60 Billion Facts"), /*#__PURE__*/React.createElement(motion.a, {
    className: "btn btn-ghost",
    href: "probiotic-24.html",
    whileHover: {
      scale: 1.05
    },
    whileTap: {
      scale: .95
    }
  }, "Kids 24 Billion"), /*#__PURE__*/React.createElement(motion.a, {
    className: "btn btn-ghost",
    href: "multivitamin.html",
    whileHover: {
      scale: 1.05
    },
    whileTap: {
      scale: .95
    }
  }, "Multivitamin")), /*#__PURE__*/React.createElement(Reveal, null, /*#__PURE__*/React.createElement("p", {
    className: "facts-note",
    style: {
      marginTop: 34,
      maxWidth: 760,
      marginInline: 'auto'
    }
  }, "*These statements have not been evaluated by the Food and Drug Administration. These products are not intended to diagnose, treat, cure, or prevent any disease.")))), /*#__PURE__*/React.createElement(Footer, null));
}
ReactDOM.createRoot(document.getElementById('root')).render(/*#__PURE__*/React.createElement(SciencePage, null));})();
